// No edvid cada arquivo importava os JSONs de public/ no topo do módulo. Aqui o mesmo dado chega
// como props da composição (ReelsProps) e desce por contexto — os componentes leem
// `useReels()` onde o edvid lia `editData`, `captions`, `segData`, `track` e `cues`.
import React, { createContext, useContext } from 'react';
import { Audio } from 'remotion';
import type { ReelsProps } from './types';

export const DEFAULT_ASSET_BASE = '/video-compositions';

export type ReelsData = ReelsProps & { assetBase: string };

const Ctx = createContext<ReelsData | null>(null);

export const ReelsProvider: React.FC<{ value: ReelsData; children: React.ReactNode }> = ({ value, children }) => (
  <Ctx.Provider value={value}>{children}</Ctx.Provider>
);

export function useReels(): ReelsData {
  const v = useContext(Ctx);
  if (!v) throw new Error('useReels() fora da composição Reels');
  return v;
}

/** URL de um estático da composição (sfx/…, trilha relativa). URLs absolutas passam direto. */
export function assetUrl(assetBase: string, file: string): string {
  if (/^(https?:|data:|blob:)/i.test(file) || file.startsWith('/')) return file;
  return `${assetBase.replace(/\/$/, '')}/${file.replace(/^\//, '')}`;
}

// SFX played at an appearance (whoosh) or a pop for shapes
export const Sfx: React.FC<{ src: string; volume?: number }> = ({ src, volume = 0.09 }) => {
  const { assetBase } = useReels();
  return <Audio src={assetUrl(assetBase, `sfx/${src}`)} volume={volume} />;
};

export const clamp = (v: number, lo: number, hi: number) => Math.max(lo, Math.min(hi, v));
export const clamp01 = (v: number) => clamp(v, 0, 1);
